import { render, staticRenderFns } from "./PassReset.vue?vue&type=template&id=236b0969"
import script from "./PassReset.vue?vue&type=script&lang=js"
export * from "./PassReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports